
import { Box, Modal, View } from "native-base";
import { Platform, Text, TouchableHighlight } from "react-native";
import Entypo from '@expo/vector-icons/Entypo';
import Fontisto from '@expo/vector-icons/Fontisto';
import { useTypedSelector } from "../../redux/store";

export const PayTipCoin = ({
  open,
  setOpen,
  delCoins,
  onChange
}:{
  open: boolean;
  setOpen: (open: boolean) => void;
  delCoins: number;
  onChange: ()=> void;
}) => {
  const userCurrent = useTypedSelector((state) => state.userCurrent);

  return (
    <Modal isOpen={open} size="full" bg="black.700:alpha.70"
      justifyContent="center" alignItems="center"
      style={{
        width: "100%", maxWidth: 460,
        marginLeft: "auto", marginRight: "auto",
      }}>
      <Modal.CloseButton _icon={{ color: "white" }} position="absolute"
        right={2} top={Platform.OS === 'ios' ? 12 : 2} zIndex={2}
        onPress={()=>{setOpen(false)}} />

      <View style={{ width: "100%", alignItems: "center" }}>
        <Entypo name="emoji-sad" size={48}
          style={{ fontWeight: "900" }}
          color="#FFFFFF" />
        <Text style={{
          color: "#FFFFFF", fontSize: 24, fontWeight: "bold",
          marginTop: 16,
          textAlign: "center"
        }}>
          Insufficient Coin
        </Text>
        <Text style={{
          color: "#FFFFFF", fontSize: 14, fontWeight: "bold",
          marginBottom: 16, marginTop: 4,
          textAlign: "center"
        }}>
          Just need {50 - userCurrent.coins} coin to make another call
        </Text>
        <Box style={{
          flexDirection: "row", gap: 10, alignItems: "center",
        }}>
          <Box style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 10,
            borderRadius: 20,
            padding: 2,
            paddingLeft: 12,
            paddingRight: 12,
            borderWidth: 1,
            borderColor: "#007AFF",
            borderStyle: "solid"
          }}>
            <Fontisto name="database" size={16} color="#FFFFFF" />
            <Text style={{
              color: "#FFFFFF", fontSize: 18, fontWeight: "bold",
            }}>{userCurrent.coins}</Text>
          </Box>
          <Text style={{
            color: "#DD0000", fontSize: 18, fontWeight: "bold",
          }}>- {delCoins} Coin</Text>
        </Box>
        <View style={{ height: 60, padding: 10, marginTop: 20 }}>
          <TouchableHighlight style={{
            height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10,
            width: 200,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            alignItems: "center", justifyContent: "center"
          }} onPress={onChange}>
            <Text style={{
              fontSize: 18, color: "#FFFFFF", fontWeight: "700"
            }}>
              Purchase coins
            </Text>
          </TouchableHighlight>
        </View>
      </View>
    </Modal>
  )
};